export enum CurrencyCode {
  RUR = 'RUR',
  USD = 'USD',
  EUR = 'EUR',
  BTC = 'BTC',
  BCC = 'BCC',
  ETH = 'ETH',
  TRX = 'TRX',
  KZT = 'KZT',
  TRY = 'TRY',
  GEL = 'GEL',
  ARS = 'ARS',
  COP = 'COP',
  MXN = 'MXN',
  BRL = 'BRL',
  PES = 'PES', // Peru Sol
  PEN = 'PEN',  // Peru Sol
  ECS = 'ECS', // Ecuador Sucre
  CRC = 'CRC', // Costa Rica Colon
  BOB = 'BOB', // Bolivian Boliviano
  USDT = 'USDT',
  USDTt = 'USDTt',
  USDC = 'USDC',
  INR = 'INR', // Indian Rupee
  IDR = 'IDR', // Indonesian Rupiah
  BO_USDT_ERC = 'USDT-ERC',
  BO_USDT_TRC = 'USDT-TRC',
  SIMPLE_USDT_ERC = 'USDT-ERC',
  SIMPLE_USDT_TRC = 'USDT-TRC',
  UNKNOWN = 'UNKNOWN',
  UAH = 'UAH',
  UZS = 'UZS',
  AZN = 'AZN',
  CLP = 'CLP',

  MYR = 'MYR',
  THB = 'THB',
  KRW = 'KRW'
}

export function backofficeCurrencyFilter(currency: CurrencyCode) {
  const currencies: Record<any, any> = {
    [CurrencyCode.USDT]: CurrencyCode.BO_USDT_ERC,
    [CurrencyCode.USDTt]: CurrencyCode.BO_USDT_TRC,
  }
  if (currency in currencies)
    return currencies[currency];

  return currency;
}

export function backofficeCurrencyFilterReversed(currency: CurrencyCode) {
  const currencies: Record<any, any> = {
    [CurrencyCode.BO_USDT_ERC]: CurrencyCode.USDT,
    [CurrencyCode.BO_USDT_TRC]: CurrencyCode.USDTt,
  }
  if (currency in currencies)
    return currencies[currency];

  return currency;
}

export function frontofficeCurrencyFilter(currency: CurrencyCode, long = false) {
  const currencies: Record<any, any> = long ? {
    ['USDT-TRC20']: 'USDT (TRC20)',
    ['USDT-ERC20']: 'USDT (ERC20)',
    ['USDT-TRC']: 'USDT (TRC20)',
    ['USDT-ERC']: 'USDT (ERC20)',
    [CurrencyCode.USDT]: 'USDT (ERC20)',
    [CurrencyCode.USDTt]: 'USDT (TRC20)',
    [CurrencyCode.USDC]: 'USDC (ERC20)',
  } : {
    ['USDT-TRC20']: 'USDT',
    ['USDT-ERC20']: 'USDT',
    ['USDT-TRC']: 'USDT',
    ['USDT-ERC']: 'USDT',
    [CurrencyCode.USDT]: 'USDT',
    [CurrencyCode.USDTt]: 'USDT',
  };

  if (currency in currencies) return currencies[currency];

  return currency;
}

export const isCardsProAccountNumber = (number: string) => {
  return number && /^[EU]CP\d+$/i.test(number);
}

export const getAccountNumberCurrency = (number: string) => {

  const currencies = {
    U: CurrencyCode.USD,
    R: CurrencyCode.RUR,
    E: CurrencyCode.EUR,
    B: CurrencyCode.BTC,
    C: CurrencyCode.BCC,
    H: CurrencyCode.ETH,
    T: CurrencyCode.USDT,
    Y: CurrencyCode.USDTt,
    W: CurrencyCode.USDC
  }

  if (!number) return null;

  const char = String(number).charAt(0);

  return currencies[char] || null;
}


export const isFiatCurrency = (currency: CurrencyCode) => {
  return [CurrencyCode.RUR, CurrencyCode.USD, CurrencyCode.EUR, CurrencyCode.KZT, CurrencyCode.TRY, CurrencyCode.GEL, CurrencyCode.ARS, CurrencyCode.COP, CurrencyCode.MXN, CurrencyCode.BRL, CurrencyCode.INR, CurrencyCode.UAH, CurrencyCode.UZS].includes(currency);
}

export const isCryptoCurrency = (currency: CurrencyCode) => {
  return [CurrencyCode.BTC, CurrencyCode.BCC, CurrencyCode.ETH, CurrencyCode.TRX,
    CurrencyCode.USDT, CurrencyCode.USDTt, CurrencyCode.USDC].includes(currency);
}

export const isMainFiatCurrency = (currency: CurrencyCode) => {
  return [CurrencyCode.RUR, CurrencyCode.USD, CurrencyCode.EUR].includes(currency);
}

export const isOtherFiatCurrency = (currency: CurrencyCode) => {
  return !isMainFiatCurrency(currency) && !isCryptoCurrency(currency);
}
